/**
 * Created by spepa on 02.08.2022
 */

const BuyFogWindow = CleverappsWindow.extend({
    onWindowLoaded: function (fogBlock) {
        this.fogBlock = fogBlock;

        this.createContent();

        this._super({
            name: "BuyFogWindow",
            title: Messages.get(`${this.fogBlock.id}.name`),
            content: this.content,
            noBackground: true,
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });

        this.fogBlock.hideBalloon();

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);

        cleverapps.focusManager.showControlsWhileFocused(this.fogBlock.isSoftMoney() ? "MenuBarCoinsItem" : "MenuBarGoldItem");
    },

    updateButton: function () {
        const product = this.fogBlock.getProduct();

        this.button.setString(this.fogBlock.getPriceTag());

        if (!product || product.isAvailable()) {
            this.button.enable();
        } else {
            this.button.disable();
        }
    },

    onClose: function () {
        if (!this.buySuccess) {
            this.fogBlock.showBalloon();
        }
    },

    createContent: function () {
        this.content = new cc.Node();
        this.content.setAnchorPoint(0.5, 0.5);
        this.content.setContentSize2(cleverapps.styles.BuyFogWindow);

        this.createIsland();
        this.createBadge();
        this.createGoods();
        this.createButton();

        this.showUpAnimation();
    },

    showUpAnimation: function () {
        let delay = 0;
        const fogWindowConfig = cleverapps.meta.getSelectedLocation().locationConfig.fogWindow || {};

        this.island.cells.forEach((cell) => {
            if (delay < cell.delay + 0.5) {
                delay = cell.delay + 0.5;
            }

            [fogWindowConfig.noDelayBorder ? undefined : cell.border, cell.unit, cell.ground].filter(Boolean).forEach((node) => {
                if (node) {
                    node.setScale(0);
                    node.runAction(new cc.Sequence(
                        new cc.DelayTime(cell.delay),
                        new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
                    ));
                }
            });
        });

        this.badge.setVisible(false);
        if (this.balloons) {
            this.balloons.setVisible(false);
        }

        this.content.runAction(new cc.Sequence(
            cleverapps.effects.fireAction([cleverapps.skins.getSlot("buyFogWindowEffect"), "buyfogwindow.show"].filter(Boolean)),
            new cc.DelayTime(delay + 0.3),
            new cc.CallFunc(() => {
                this.badge.setVisible(true);
                this.badge.setScale(0);
                this.badge.runAction(new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut()));
                if (this.balloons) {
                    this.balloons.setVisible(true);
                    this.balloons.replaceParentSamePlace(this, { keepScale: true });
                    this.balloons.setAnimation(0, "open", false);
                    this.balloons.setCompleteListenerOnce(() => {
                        this.balloons.replaceParentSamePlace(this.content, { keepScale: true });
                        this.balloons.setAnimation(0, "idle", true);
                    });
                }
            })
        ));

        this.button.setScale(0);
        this.button.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
        ));

        this.goodsTitle.setOpacity(0);
        this.goodsTitle.runAction(new cc.Sequence(
            new cc.DelayTime(delay + 0.5),
            new cc.FadeTo(0.2, 255)
        ));

        if (this.goodsTile) {
            this.goodsTile.setScale(0);
            this.goodsTile.runAction(new cc.Sequence(
                new cc.DelayTime(delay + 0.5),
                new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut())
            ));
        }

        if (this.islandShine) {
            this.islandShine.setScale(0);
            this.islandShine.runAction(new cc.Sequence(
                new cc.DelayTime(delay),
                new cc.ScaleTo(0.6, 1)
            ));
        }

        this.items.setScale(0);
        this.items.runAction(new cc.Sequence(
            new cc.DelayTime(delay + 0.5),
            new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
        ));
    },

    createBadge: function () {
        const badge = this.badge = new TileBadge({
            rotation: 0,
            type: "value",
            value: "200%"
        });
        this.content.addChild(badge);
        const pos = cleverapps.styles.BuyFogWindow.badge;
        badge.setAlignment(this.content.width / 2 + (this.island.width * this.island.scale) / 2 + badge.width / 2 + pos.x, this.content.height / 2 + pos.y);
    },

    createIsland: function () {
        const balloons = this.balloons = new cleverapps.Spine(bundles.merge.jsons.fog_balloon_json);
        const styles = cleverapps.styles.BuyFogWindow;
        const map = Map2d.currentMap;

        const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
        const fogWindowConfig = locationConfig.fogWindow || {};
        const hasDecorators = fogWindowConfig.hasDecorators || cleverapps.config.name === "hustlemerge" && locationConfig.isMain;
        const withShine = cleverapps.config.name === "hustlemerge" && locationConfig.isMain;
        const emptySlotsDecorators = fogWindowConfig.emptySlotsDecorators;

        let decorTiles = [];
        if (hasDecorators) {
            decorTiles = map.fogs.getTilesWithDecorators(this.fogBlock, emptySlotsDecorators);
        }

        const savedWaterLayer = map.layers[Map2d.LAYER_WATER];
        const savedGroundLayer = map.layers[Map2d.LAYER_GROUND];

        const isFogBlockTile = function (x, y) {
            return this.fogBlock.tiles.concat(decorTiles.filter((dt) => map.isImpassableGround(dt.x, dt.y))).filter((bt) => bt.x === x && bt.y === y).length > 0;
        }.bind(this);

        map.layers[Map2d.LAYER_WATER] = map.map(map.groundMap, (cell, x, y) => (isFogBlockTile(x, y) ? undefined : Map2d.TILE_WATER));
        map.layers[Map2d.LAYER_GROUND] = map.map(map.groundMap, (cell, x, y) => (isFogBlockTile(x, y) ? cell : undefined));

        const cells = [];
        let island = new cc.Node();
        island.setAnchorPoint(0.5, 0.5);

        let x, y, miny = 100000;
        this.fogBlock.tiles.forEach((tile) => {
            if (miny > tile.y) {
                miny = tile.y;
            }
        });

        this.fogBlock.tiles.forEach((tile) => {
            map.setPointer(tile.x, tile.y);
            const groundView = ViewReader.parse(map.getGround(Iso.SAME), map);
            if (x === undefined) {
                x = tile.x;
                y = tile.y;
            }
            const dx = tile.x - x;
            const dy = tile.y - y;
            const X = dx + dy + 1;
            const Y = dx - dy;
            groundView.setAlignment(X * cleverapps.styles.Map2dView.cell.width / 2, Y * cleverapps.styles.Map2dView.cell.height / 2);
            groundView.setLocalZOrder(1000 - Y);
            island.addChild(groundView, 1);

            const chessGroundView = ViewReader.parse(map.getTileAboveGround(Iso.SAME), map);
            if (chessGroundView) {
                chessGroundView.setAlignment(X * cleverapps.styles.Map2dView.cell.width / 2, Y * cleverapps.styles.Map2dView.cell.height / 2);
                island.addChild(chessGroundView, 2);
            }

            const unit = tile.getFakeUnit();
            let unitView;
            if (unit && !unit.head) {
                unitView = UnitView.getUnitImage(unit, {
                    alignAnchorX: true,
                    alignAnchorY: true
                });
                unitView.setAlignment(groundView.getPosition());
                unitView.setLocalZOrder(10000 - Y);
                island.addChild(unitView, 3);

                MultiCellView(unit, unitView);

                if (unit.grounded) {
                    const grounded = new cc.Sprite(GroundedView.getImage(unit.x, unit.y));

                    grounded.setAlignment(groundView.width / 2, groundView.height / 2);
                    groundView.addChild(grounded);
                }
            }

            let borderView = undefined;
            if (this.fogBlock.isBorderTile(tile) && (!hasDecorators || hasDecorators && emptySlotsDecorators)) {
                borderView = this.createCellBorder();
                borderView.setAlignment(groundView.getPosition());
                island.addChild(borderView, -1);
            }

            cells.push({
                ground: hasDecorators ? undefined : groundView,
                unit: unitView,
                border: borderView,
                delay: 0.1 * (tile.y - miny) + 0.3
            });
        });

        const balloonData = this.fogBlock.getBalloon();
        if (balloonData) {
            const balloons = this.balloons;
            balloons.setLocalZOrder(1000);
            const skins = balloons.listSkins();
            if (skins.length > 0) {
                balloons.setSkin(`${this.fogBlock.options.id % skins.length}`);
            }

            if (cleverapps.skins.getSlot("fogballoon_showup_effect")) {
                cleverapps.effects.fire(cleverapps.skins.getSlot("fogballoon_showup_effect"));
            }

            if (hasDecorators && !emptySlotsDecorators) {
                const dx = balloonData.tile.x - x;
                const dy = balloonData.tile.y - y;
                const offset = cleverapps.styles.FogBalloonView.animation;
                balloons.setAlignment((dx + dy + 1) * cleverapps.styles.Map2dView.cell.width / 2 + offset.x.dx, (dx - dy) * cleverapps.styles.Map2dView.cell.height / 2 + offset.y.dy);
                island.addChild(balloons);
            } else {
                this.content.addChild(balloons);
            }
        }

        let highestDecorPoint = 0;
        let lowestDecorPoint = 0;
        decorTiles.forEach((tile) => {
            const dx = tile.x - x;
            const dy = tile.y - y;
            const position = cc.p((dx + dy + 1) * cleverapps.styles.Map2dView.cell.width / 2, (dx - dy) * cleverapps.styles.Map2dView.cell.height / 2);

            const tileDecor = new cc.Node();
            const tileBorders = new cc.Node();
            tileDecor.setAlignment(position);
            tileBorders.setAlignment(position);

            (map.decorators.getDecorators(tile.x, tile.y) || []).filter((decorator) => !this.fogBlock.options.noTerrainInBuyWindow || decorator.code.indexOf("terrains_") === -1).forEach((decorator) => {
                const ViewClass = decorator.getViewClass();
                const decorView = new ViewClass(decorator);

                if (decorator.getLayerId() === Map2d.LAYER_BORDERS) {
                    tileBorders.addChild(decorView);
                } else {
                    tileDecor.addChild(decorView);
                }
            });

            const borderTile = map.getValue(Map2d.LAYER_BORDERS, tile.x, tile.y);

            if (borderTile) {
                tileBorders.addChild(Map2dBorderView.GetFromPool(borderTile), -1);
            }

            if (!this.fogBlock.options.noTerrainInBuyWindow) {
                island.addChild(tileBorders, -1);
            }

            island.addChild(tileDecor, 2);

            const decorBox = tileDecor.getBoundingBoxToWorld();
            if (decorBox.y + decorBox.height > highestDecorPoint) {
                highestDecorPoint = decorBox.y + decorBox.height;
            }
            if (decorBox.y < lowestDecorPoint) {
                lowestDecorPoint = decorBox.y;
            }
        });

        island = this.island = cleverapps.UI.wrap(island);
        island.setScale(Math.min(1, styles.island.height / island.getBoundingBoxToWorld().height));
        this.content.addChild(island);
        island.setAlignment(styles.island);

        if (withShine) {
            this.islandShine = new cleverapps.Spine(bundles.buyfogwindow.jsons.fog_shine_json);
            this.islandShine.setAnimation(0, "animation", true);
            this.islandShine.setAlignment(styles.island.shine);
            island.addChild(this.islandShine, -2);

            if (highestDecorPoint - lowestDecorPoint > island.height) {
                island.setContentSize(island.width, highestDecorPoint - lowestDecorPoint);
            }
        }

        this.island = island;

        this.island.cells = cells;

        if (this.balloons && !withShine) {
            const pos = styles.balloons;
            this.balloons.setAlignment(this.content.width / 2 - (this.island.width * this.island.scale) / 2 - balloons.width / 2 + pos.x, this.content.height / 2 + pos.y);
            this.balloons.setScale(1.3);
        }

        map.layers[Map2d.LAYER_WATER] = savedWaterLayer;
        map.layers[Map2d.LAYER_GROUND] = savedGroundLayer;
    },

    createCellBorder: function (customBundle) {
        const border = new cleverapps.Spine(customBundle || bundles.buyfogwindow.jsons.island_shine_json);
        border.setAnimation(0, "animation", true);
        border.setSkin(this.fogBlock.options.windowSkin ? this.fogBlock.options.windowSkin : "base");
        return border;
    },

    createGoods: function () {
        const styles = cleverapps.styles.BuyFogWindow.goods;

        const goods = new cleverapps.Layout([this.createGoodsTitle(), this.createValuables()], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.linesMargin
        });

        this.content.addChild(goods);
        goods.setAlignment(styles);
    },

    createGoodsTitle: function () {
        const styles = cleverapps.styles.BuyFogWindow.goods;

        if (cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
            this.goodsTitle = cleverapps.UI.generateOnlyText(Messages.get("BuyFogWindow.tiles", {
                tiles: this.fogBlock.tiles.length
            }), cleverapps.styles.FONTS.BUY_FOG_WINDOW_GOODS_TILES);

            if (cleverapps.config.name === "hustlemerge") {
                return this.goodsTitle;
            } 
            const tile = new cc.Node();
            this.goodsTile = tile;
            tile.setAnchorPoint(0.5, 0.5);
            const map = Map2d.currentMap;
            map.setPointer(this.fogBlock.tiles[0].x, this.fogBlock.tiles[0].y);
            const ground = map.getGround(Iso.SAME);
            const cell = ViewReader.parse(ground, map);
            const border = this.createCellBorder();

            tile.setContentSize(border.getContentSize());
            cell.setAlignment(tile.width / 2, tile.height / 2);
            border.setAlignment(tile.width / 2, tile.height / 2);
            tile.addChild(border);
            tile.addChild(cell);

            return new cleverapps.Layout([this.goodsTile, this.goodsTitle], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.tilesMargin
            });
        }
        this.goodsTitle = cleverapps.UI.generateOnlyText(Messages.get("BuyFogWindow.valuables"), cleverapps.styles.FONTS.BUY_FOG_WINDOW_BONUS);
        return this.goodsTitle;
    },

    generateValuables: function () {
        const count = {};
        this.fogBlock.tiles.forEach((tile) => {
            const unit = tile.getFakeUnit();
            if (unit && unit.code) {
                const key = Unit.GetKey(unit);
                count[key] = (count[key] || 0) + 1;
            }
        });

        const units = [];
        for (const key in count) {
            const unit = Unit.ParseKey(key);
            unit.amount = count[key];
            unit.price = Families[unit.code].units[unit.stage].price * unit.amount;
            units.push(unit);
        }
        units.sort((a, b) => b.price - a.price);
        return units.slice(0, 3);
    },

    createValuables: function () {
        const styles = cleverapps.styles.BuyFogWindow.goods;

        const bubbles = this.fogBlock.options.bubbles;
        const valuables = bubbles && bubbles.length > 0 ? bubbles : this.generateValuables();

        this.items = new RewardsListComponent(RewardTypes.units.parse(valuables, { toMainWorld: true }), {
            shine: true,
            margin: styles.itemsMargin,
            font: cleverapps.styles.FONTS.BUY_FOG_WINDOW_GOODS_UNITS,
            textDirection: cleverapps.UI.HORIZONTAL
        });

        return this.items;
    },

    createButton: function () {
        const styles = cleverapps.styles.BuyFogWindow.button;
        const button = this.button = new cleverapps.UI.Button({
            text: this.fogBlock.getPriceTag(),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                this.fogBlock.buy(this.createListener((success) => {
                    if (success) {
                        if (this.balloons) {
                            if (cleverapps.skins.getSlot("fogballoon_buy_effect")) {
                                cleverapps.effects.fire(cleverapps.skins.getSlot("fogballoon_buy_effect"));
                            }

                            this.balloons.replaceParentSamePlace(Map2d.currentMap.getMapView().animations, { keepScale: true });
                            this.balloons.setAnimation(0, "close", false);
                            this.balloons.setCompleteListenerRemove();
                            this.buySuccess = true;
                        }
                        this.close();
                    } else {
                        this.updateButton();
                    }
                }));
            }.bind(this)
        });
        this.content.addChild(button);

        this.updateButton();

        button.setAlignment(styles);
    },

    listBundles: function () {
        return ["buyfogwindow", "buyfogwindow_person"];
    }

});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUY_FOG_WINDOW_BONUS: {
        size: 55,
        color: cleverapps.styles.COLORS.YELLOW_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BUY_FOG_WINDOW_GOODS_TILES: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BUY_FOG_WINDOW_GOODS_UNITS: {
        size: 55,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.BuyFogWindow = {
    width: 1100,
    height: 1000,

    badge: {
        x: 0,
        y: 380
    },

    balloons: {
        x: 0,
        y: 250
    },

    island: {
        width: 1300,
        height: 580,
        x: { align: "center" },
        y: { align: "center", dy: 190 }
    },

    goods: {
        x: { align: "center" },
        y: { align: "center", dy: -240 },
        linesMargin: 0,
        tilesMargin: 10,
        itemsMargin: {
            x: 80,
            y: 40
        },

        item: {
            width: 130,
            height: 130,
            maxScale: 1.45
        }
    },

    button: {
        width: 250,
        height: 100,
        x: { align: "center" },
        y: { align: "bottom", dy: 0 }
    }
};
